import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from './register/register.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CredentialsComponent } from './credentials/credentials.component';
import { IRegistrationState, registrationInitialState } from './store/state';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { RouterModule } from '@angular/router';
import { RegistrationComponent } from './registration.component';
import { ButtonModule } from '@roosevelt/common-ui-lib/button';
import { InputModule } from '@roosevelt/common-ui-lib/input';
import { LoaderModule } from '@roosevelt/common-ui-lib/loader';
import { SelectModule } from '@roosevelt/common-ui-lib/select';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { syncLuxSliceToStorage } from '../shared/lux-storage-sync';

@NgModule({
  declarations: [RegisterComponent, RegistrationComponent, CredentialsComponent, ConfirmationComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    ButtonModule,
    SelectModule,
    RouterModule,
    LoaderModule
  ]
})
export class RegistrationModule {
  constructor(lux: Lux<{ registration: IRegistrationState }>, injector: Injector) {
    const registrationState = JSON.parse(sessionStorage.getItem('registration-state'));
    lux.register('registration', registrationState || registrationInitialState);
    syncLuxSliceToStorage(
      lux,
      injector,
      sessionStorage,
      'registration-state',
      state => state.registration
    );
  }
}
